import * as brokerHooks from "@rentiohq/shared-frontend/dist/redux/broker/broker.hooks";
import * as propertyHooks from "@rentiohq/shared-frontend/dist/reduxV2/property/property.hooks";
import { EBrokerFeature } from "@rentiohq/shared-frontend/dist/types/broker.types";
import { Can } from "@rentiohq/web-shared/dist/components";
import { Navigate, useParams } from "react-router-dom";
import { PaymentsOverview } from "../scenes/PaymentsOverview";
import { PaymentsOverview as PaymentsOverviewV2 } from "./PaymentsOverview";

interface IProps {
  forceVersion?: 1 | 2;
}

export const PaymentsOverviewContainer = (props: IProps) => {
  const { forceVersion } = props;

  const params = useParams<{ propertyId: string }>();

  const propertyId = params.propertyId ? +params.propertyId : undefined;

  const { detail: property } = propertyHooks.useDetail({
    shouldRefetch: false,
    id: propertyId,
  });

  const hasPaymentV2ForBroker = brokerHooks.useBrokerFeature(
    EBrokerFeature.PaymentV2,
  );

  const renderContent = () => {
    if (!property) {
      return;
    }

    if (forceVersion === 1) {
      return <PaymentsOverview property={property} />;
    }

    if (forceVersion === 2) {
      return <PaymentsOverviewV2 property={property} />;
    }

    if (hasPaymentV2ForBroker) {
      return <PaymentsOverviewV2 property={property} />;
    }

    return <PaymentsOverview property={property} />;
  };

  return (
    <Can
      role={property?.roles}
      perform="propertyPayments:visit"
      yes={renderContent}
      no={() => <Navigate to={`/properties/${propertyId}`} />}
    />
  );
};
